import React from 'react';
import { makeStyles } from '@mui/styles';
import resourcesIconPng from 'assets/images/icons/ResourcesWhite.png';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import BasicButton from './BasicButton';
import { useResources } from 'state/providers/ResourcesProvider';
import { remCalc } from 'util/style-util';
import { translate } from '../../../translations/translator';
const translateResources = key => translate('resources', key);

const ResourcesButton = ({ buttonClass = {} }) => {
  const classes = useStyles();
  const [{ isOpen }, { setIsOpen }] = useResources();

  if (isOpen) return null;

  return (
    <BasicButton
      id="resourcesButton"
      onClick={() => setIsOpen(!isOpen)}
      buttonStyles={[classes.button, buttonClass]}
    >
      <div className={classes.content}>
        <ChevronLeftIcon />
        <img
          src={resourcesIconPng}
          className={classes.iconImage}
          alt={translateResources('title')}
        />
      </div>
    </BasicButton>
  );
};

const useStyles = makeStyles(() => ({
  button: {
    zIndex: 9999,
    backgroundColor: 'transparent',
    textAlign: 'center',
    marginRight: 10,
    '&:hover': {
      transform: 'scale(1.05, 1.05)'
    }
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  iconImage: {
    height: remCalc(40)
  }
}));

export default ResourcesButton;
